module.exports = __webpack_public_path__ + "img/ai.7394fd38.png";